export const recaptchaId = {
    loginCheckbox: 'LoginCheckbox',
    loginScore: 'LoginScore',
    loginDrawerCheckbox: 'LoginDrawerCheckbox',
    loginDrawerScore: 'LoginDrawerScore',
    /** actual password change */
    resetPasswordCheckbox: 'ResetPasswordCheckbox',
    /** actual password change */
    resetPasswordScore: 'ResetPasswordScore',
    /** request password change */
    forgotPasswordCheckbox: 'ForgotPasswordCheckbox',
    /** request password change */
    forgotPasswordScore: 'ForgotPasswordScore',
    giftCard: 'GiftCard',
};
